/**
 * create-data-export-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { StdVariable } from "../../../aggregation/typed-parameter";
import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

export interface TableDescription
{
  table : string;
  members : string[];
}

@validateFor(MessageTag.RSP_CREATE_DATA_EXPORT)
export class CreateDataExportResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_CREATE_DATA_EXPORT;

  @validateOpaqueID()
  public exportId : number;

  @validateAs({array: "object"})
  public targetVariableOptions : StdVariable[];

  @validateAs({array: "object"})
  public filterOptions : StdVariable[];

  @validateAs({array: "object"})
  public tables : TableDescription[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/export/create-data-export-response.ts